import { Trans } from '@lingui/react'
import type { VFC } from 'react'

interface ExcludedAttributeValueProps {
  attributeValue: string
  code: string
}

const ExcludedAttributeValue: VFC<ExcludedAttributeValueProps> = ({
  attributeValue,
  code,
}) => {
  let excludedAttributeLabel
  switch (code) {
    case 'package_size':
      excludedAttributeLabel = (
        <Trans id="variantAttributes.label.package_size" />
      )
      break
    case 'size':
      excludedAttributeLabel = <Trans id="variantAttributes.label.size" />
      break
    case 'color_number':
      excludedAttributeLabel = (
        <Trans id="variantAttributes.label.color_number" />
      )
      break
    case 'cannula_length':
      excludedAttributeLabel = (
        <Trans id="variantAttributes.label.cannula_length" />
      )
      break
    case 'tube_length':
      excludedAttributeLabel = (
        <Trans id="variantAttributes.label.tube_length" />
      )
      break
    case 'nominal_weight':
      excludedAttributeLabel = (
        <Trans id="variantAttributes.label.nominal_weight" />
      )
      break
    case 'resistance':
      excludedAttributeLabel = <Trans id="variantAttributes.label.resistance" />
      break
    case 'book_type':
      excludedAttributeLabel = <Trans id="variantAttributes.label.book_type" />
      break
    case 'flavor':
      excludedAttributeLabel = <Trans id="variantAttributes.label.flavor" />
      break
    case 'cbd_content':
      excludedAttributeLabel = (
        <Trans id="variantAttributes.label.cbd_content" />
      )
      break
    case 'patch_size':
      excludedAttributeLabel = <Trans id="variantAttributes.label.patch_size" />
      break
    default:
      return null
  }

  return (
    <div className="u-padding-small--bottom u-padding-small--top ">
      <span>{excludedAttributeLabel}: </span>
      <span className={'u-font-weight--bold'}>{attributeValue}</span>
    </div>
  )
}

export default ExcludedAttributeValue
